export default __webpack_public_path__ + "static/media/Antibes-Green.692f72fd.jpg";